<template>
    <Modal v-model="showModal" title="培训课程自动同步配置" :footer-hide="true" width="950" class="top">
        <Form :model="formData" ref="formRef" :label-width="125" class="form">
            <FormItem label="平台素材更新后是否自动同步" :label-width="195" class="less">
                <RadioGroup v-model="formData.autoSync">
                    <Radio label="0">不同步</Radio>
                    <Radio label="1">同步</Radio>
                </RadioGroup>
            </FormItem>

            <FormItem
                label="自动同步到机构"
                prop="orgIds"
                :rules="$units.formRule.required('请选择机构', (trigger = 'change'), (type = 'array'))"
                class="full"
            >
                <selectTree v-model="formData.orgIds" :multiple="true" type="4" ref="selectTreeRef" @getTreeData="getTreeData"></selectTree>
            </FormItem>

            <FormItem label="同步后是否自动上架" class="less" :label-width="140">
                <RadioGroup v-model="formData.autoPutShelf">
                    <Radio label="1">上架</Radio>
                    <Radio label="0">不上架</Radio>
                </RadioGroup>
            </FormItem>

            <div class="title">
                <span>分类配置</span>
            </div>
            <div class="page-form material" v-for="(item, index) in formData.columnVOs" :key="item.id">
                <FormItem
                    label="将素材库分类"
                    :prop="'columnVOs.' + index + '.sourceIds'"
                    :rules="$units.formRule.arrRequired('请选择分类', 'change')"
                    style="width: 45%"
                >
                    <selectTreeOld
                        :data="columnList1"
                        :multiple="true"
                        :size="null"
                        placeholder="请选择"
                        :single="true"
                        :showParentNode="true"
                        :selectAllChildren="true"
                        @onChange="(name, ids) => columnChange(name, ids, index, 1)"
                        :value="item.sourceIds"
                    ></selectTreeOld>
                </FormItem>

                <FormItem
                    label="的内容同步至"
                    :prop="'columnVOs.' + index + '.courseIds'"
                    :rules="$units.formRule.arrRequired('请选择分类', 'change')"
                    style="width: 45%"
                >
                    <selectTreeOld
                        :data="columnList2"
                        :multiple="false"
                        :size="null"
                        placeholder="请选择"
                        :single="true"
                        :showParentNode="true"
                        :selectAllChildren="false"
                        @onChange="(name, ids) => columnChange(name, ids, index, 2)"
                        :value="item.courseIds"
                    ></selectTreeOld>
                </FormItem>
                <div class="material-config">
                    <a class="action" @click="delColumnVOsItem(index)" v-if="formData.columnVOs.length != 1">删除</a>
                    <a class="action" @click="addColumnVOsItem(index)" v-show="index+1==formData.columnVOs.length">添加</a>              
                </div>
            </div>

            <div class="ivu-modal-footer">
                <Button type="text" @click="showModal = false">取消</Button>
                <Button type="primary" @click="confirm">确认</Button>
            </div>
        </Form>
    </Modal>
</template>
<script>
import selectTree from '@/components/system/selectTree3';
import selectTreeOld from '@/components/commons/selectTree';
export default {
    components: {
        selectTree,
        selectTreeOld
    },
    data() {
        return {
            showModal: false,
            columnList1: [],
            columnList2: [],
            formData: {}
        };
    },

    methods: {
        open() {
            this.showModal = true;
            this.material1();
            this.material2();
            this.getDetail();
        },

        // 获取详情
        getDetail() {
            this.$http({
                url: `/buz/courseSyncConfiguration/query/detail`,
                type: 'POST',
                data: {}
            }).then(res => {
                if(res.data&&res.data.columnVOs){
                    this.formData = res.data;
                    this.$nextTick(() => {
                        this.$refs.selectTreeRef && this.$refs.selectTreeRef.openChange();
                    });
                }else{
                    this.formData = {
                        autoSync: '0',
                        autoPutShelf: '1',
                        orgIds: [],
                        columnVOs: [
                            {
                                sourceIds: [],
                                courseIds: [],
                                id: 0
                            }
                        ]
                    }
                }
            });
        },

        // 素材库分类
        material1() {
            this.$http({
                url: `/buz/courseColumn/cms/columnTree`,
                type: 'GET',
                data: {}
            }).then(res => {
                this.columnList1 = this.dealTree(res.data);
            });
        },
        // 素材库分类
        material2() {
            this.$http({
                url: '/buz/courseColumn/read/list',
                type: 'POST',
                data: {}
            }).then(res => {
                this.columnList2 = this.dealTree(res.data);
            });
        },
        dealTree(arr) {
            return arr.map(item => ({
                ...item,
                value: item.id,
                label: item.name,
                title: item.name,
                expand: true,
                children: item.children && item.children.length > 0 ? this.dealTree(item.children, item.name) : null
            }));
        },

        // 获取树节点id
        getTreeData(data) {
            this.depData(data);
            this.$nextTick(() => {
                this.$refs.selectTreeRef.setSelectIdByChecked();
            });
        },
        depData(data) {
            data.forEach(item => {
                this.$set(item, 'checked', true);
                item.children.length ? this.depData(item.children) : [];
            });
        },

        // 选中分类配置
        columnChange(name, ids, index, isClass) {
            if(isClass == 1) {
                this.$set(this.formData.columnVOs[index], 'sourceIds', ids);
            }else{
                this.$set(this.formData.columnVOs[index], 'courseIds', ids);
            }            
        },

        // 添加
        addColumnVOsItem() {
            this.formData.columnVOs.push({
                sourceIds: [],
                courseIds: [],
                id: Date.now()
            });
        },

        // 删除
        delColumnVOsItem(index) {
            this.formData.columnVOs.splice(index, 1);
        },

        confirm() {
            this.$refs['formRef'].validate(valid => {
                if (valid) {
                    let columnVOs = JSON.parse(JSON.stringify(this.formData.columnVOs));
                    columnVOs.forEach(item=>{
                        delete item.id
                    })
                    let data = {
                        autoSync:this.formData.autoSync,
                        autoPutShelf:this.formData.autoPutShelf,
                        orgIds:this.formData.orgIds,
                        columnVOs
                    }
                    if(this.formData.id){
                        data.id = this.formData.id;
                    }
                    this.$http({
                        url: !this.formData.id?'/buz/courseSyncConfiguration/add':'/buz/courseSyncConfiguration/edit',
                        type: 'POST',
                        data,
                        apiPermissionCode:'operate_3_1_8'
                    }).then(res => {
                        this.$Message.success('操作成功');
                        this.showModal = false;
                        this.$emit('reload');
                    });
                }
            });
        }
    }
};
</script>

<style lang="scss" scoped>
.form {
    margin-top: 5px;
    .title {
        font-size: 15px;
        font-weight: bold;
    }
    .material {
        display: flex;
        .material-config {
            margin-left: 0px;
            height: 20px;
            margin-top: 6px;
            width: 70px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            .action {
                color: #236dff;
            }
        }
    }
}
/deep/ .ivu-modal-header {
    height: 40px;
    padding-left: 20px !important;
}
/deep/ .ivu-modal-header-inner {
    font-size: 14px !important;
}
/deep/ .ivu-modal-close .ivu-icon-ios-close {
    font-size: 34px;
}
</style>
